<template>
    <v-container>
        <v-row>
            <v-col  v-for="(item,index) in myBucketData" :cols="myBucketData.length>2?'4':'6'" class="d-flex justify-center text-center" :key="index">
                <v-card
                max-width="200"
                min-width="90"
                max-height="100"
                min-height="90"
                width="100%"
                class="mb-6 mx-4 d-flex align-center justify-center flex-wrap"
                @click="itemAction(item)"
                @contextmenu.prevent="showContextMenu($event,item,index)"
                >
                    <v-img  v-if="item.activeicon" class="mt-2" contain :src="item.activeicon" max-height="40"/>
                    <span class="text-center justify-center" >{{item.name}}</span>
                </v-card>
            </v-col>
            <v-col :cols="myBucketData.length>2?'4':'6'" class="d-flex justify-center text-center">
                <v-card
                max-width="200"
                min-width="90"
                max-height="100"
                min-height="90"
                width="100%"
                class="mb-6 mx-4 d-flex align-center justify-center flex-wrap"
                @click="editDialog=true">
                    <v-icon>mdi-plus</v-icon>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-model="editDialog"
            max-width="55vw"
        >
            <v-card>
                <v-toolbar
                  color="grey lighten-4"
                  class="mb-2"
                >
                    <v-toolbar-title >{{selectedItem?'Edit ':'Add ' + editType}}</v-toolbar-title>
                        <v-btn
                          style="margin-left:87%"
                          absolute
                          icon
                          @click.stop="editDialog=false"
                          :value="-1"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                </v-toolbar>
                <div justify="center">
                    <v-select label="Type" :items="dialogTypes" :value="dialogType" solo class="mx-7 mt-4"/>
                </div>
                <component v-if="editDialog" :is="editComponent" :item="selectedItem?selectedItem:{type:dialogType}" @set-my-bucket="setMyBucket"></component>
            </v-card>
        </v-dialog>
            <v-menu
                v-model="contextMenu"
                :position-x="contextMenuX"
                :position-y="contextMenuY"
                absolute
                offset-y
              >
                <v-list>
                  <v-list-item @click="deleteItem" >
                    <v-list-item-title style="font-size:10pt;">
                      Delete
                       <v-icon style="font-size:13pt;">delete</v-icon>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="editDialog=true" >
                    <v-list-item-title style="font-size:10pt;">
                      Edit
                       <v-icon style="font-size:13pt;">edit</v-icon>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
    </v-container>
</template>
<script>
import conf from "@/config/config";
import EditUrl from '@/components/page-components/shortcut/EditUrl'
export default {
    name:"Shortcut",
    data(){
        return {
            dialogType:'url',
            dialogTypes:[
                'url'
            ],
            contextMenu:false,
            contextMenuX:0,
            contextMenuY:0,
            selectedItem:null,
            editDialog:false,
            editIndex:-1,
            myBucket:null,
            myBucketData:[],
            errorMsg: "",
            errorLoading: false,
        }
    },
    props:['mms','mmsReady'],
    mixins:[],
    components:{EditUrl},
    computed:{
        user(){
            return this.$store.getters.user;
        },
        editType(){
            return this.selectedItem!=null?this.selectedItem.type:this.dialogType;
        },
        editComponent(){
            return 'edit-'+this.editType;
        }
    },
    async created(){
        if(this.mmsReady)
            this.checkBucket();
    },
    watch:{
        async mmsReady(val){
            console.log(val);
            this.checkBucket();
        },
        myBucket(val){
            this.myBucketData=val.data;
        },
        editDialog(val){
            if(!val)this.selectedItem=null;
            this.editIndex=-1;
        },

    },
    methods:{
        itemAction(item){
            switch(item.type){
                case 'url':
                    Object.assign(document.createElement('a'), { target: '_blank', href: item.data}).click();
                    break;
            }

        },
        showContextMenu(e,item,index){
            this.contextMenu = false;
            this.selectedItem=item;
            this.editIndex=index;
            console.log(item);
            this.contextMenuX=e.clientX;
            this.contextMenuY=e.clientY;
            this.$nextTick(() => {
              this.contextMenu = true;
            })
        },
        async checkBucket(){
            try{
                if(this.mmsReady&&!this.myBucket){
                    this.myBucket=await this.loadMyBucket();
                    console.log(this.myBucket);
                    if(!this.myBucket){
                      let [{ Reply: result }] = await this.mms.callMMS({
                         topic: "",
                         DDN: conf.objstore,
                         func:  "obj://add",
                         payload: {
                          access:'private',
                          uid:this.user.Uid,
                          title: 'myBucket', name: 'myBucket', qname: 'myBucket',
                          qcode: Date.now().toString(),
                          qdigit: null,
                          type: 'object',
                          qtag: '',
                          data: []
                          }
                      });
                      if(result.ErrMsg == 'OK'){
                          this.errorCode=0;
                          this.errorMsg='OK';
                          this.myBucket=result.data;

                          console.log(`myBucket added:`,result);
                      }
                      else
                          this.errorMsg = result.ErrMsg;
                    }
                }else{
                    this.myBucketData=this.myBucket.data;
                }
            }catch(e){
                console.log(e);
            }
        },
        async deleteItem(){
            let newItem =Object.assign({},this.myBucket);
            newItem.data.splice(this.editIndex,1);
            let [{ Reply: result }] = await this.mms.callMMS({
             topic: "",
             DDN: conf.objstore,
             func: "obj://set",
             payload: newItem
          });
          if(result.ErrMsg == 'OK'){
            this.errorCode=0;
            this.errorMsg='OK';
            console.log('update result:',result);
          }else{
              this.errorMsg = result.ErrMsg;
          }
        },
        async setMyBucket(item){
        //if(!this.checkWebMMSState)
        let newItem =Object.assign({},this.myBucket);
        console.log(item,this.editIndex);
        switch(item.type){
            case 'url':
                if(item.name!=''&&/^http[s]?:\/\/\w*/g.test(item.data)){
                    if(this.editIndex!=-1)
                        newItem.data[this.editIndex]={
                            ...newItem.data[this.editIndex],
                            name:item.name,
                            data:item.data,
                            type:item.type
                        };
                    else
                        newItem.data.push({
                            qcode:Date.now().toString(),
                            name:item.name,
                            data:item.url,
                            type:item.type
                        });
                }else{
                    return;
                }
                break;
        }

        let [{ Reply: result }] = await this.mms.callMMS({
             topic: "",
             DDN: conf.objstore,
             func: "obj://set",
             payload: newItem
          });
          if(result.ErrMsg == 'OK'){
            this.errorCode=0;
            this.errorMsg='OK';
            console.log('update result:',result);
            this.editDiallogValue1=this.editDiallogValue2='';
            this.editDialog=false;
          }else{
              this.errorMsg = result.ErrMsg;
          }
      },
        checkWebMMSState(){
            if(!this.mmsReady)
            {
              this.errorMsg = "WebMMS is not connected or registered.";
              this.errorLoading = true;
              return false;
            }else return  true;

        },
        async loadMyBucket(){

          let payload = {
              condition: {'qname':'mybucket','uid':this.user.Uid },
              noCache: true,
              allData: true
          }
          if(!this.checkWebMMSState())
            return;

          try {
            console.log(payload);
          let res = await this.mms.callMMS({
              topic: '',
              DDN: conf.objstore,
              func: "obj://list",
              payload: payload
          });


          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply != ''){
                    if(result.Reply.ErrMsg == 'OK'){
                        return result.Reply.Data.Data[0];
                    }
                }
            }
          } catch (error) {
              this.errorMsg = error;
              this.errorLoading = true;
          }
      }
    }
}
</script>
